import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { PopupCampaign } from "@/services/popupService";

interface BannerStripProps {
  campaign: PopupCampaign;
  onCtaClick: () => void;
  onDismiss: () => void;
}

/** Calm, dismissible conversion strip rendered in Layout (NOT the dunning slot's
 * alarm tones). Heading/body + optional CTA + dismiss. RTL. Text wraps to two
 * lines rather than truncating mid-sentence; the ✕ is small but has a 44px hit
 * area and touch (active) feedback. */
const BannerStrip = ({ campaign, onCtaClick, onDismiss }: BannerStripProps) => {
  return (
    <div dir="rtl" className="flex items-center gap-3 border-b bg-primary/10 px-4 py-2 text-start">
      <div className="min-w-0 flex-1">
        {campaign.heading && <p className="line-clamp-2 text-sm font-semibold text-foreground">{campaign.heading}</p>}
        {campaign.body_text && <p className="line-clamp-2 text-xs text-foreground/70">{campaign.body_text}</p>}
      </div>
      {campaign.cta_label && (
        <Button size="sm" className="shrink-0" onClick={onCtaClick}>{campaign.cta_label}</Button>
      )}
      <Button
        variant="ghost" size="icon" aria-label="סגירה"
        className="tap-target h-7 w-7 shrink-0 rounded-full active:bg-background/60"
        onClick={onDismiss}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default BannerStrip;
